var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 45,
    viewBox: "0 0 89 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 34.96C2.08 31.4 2 13.84 2.52 10.52C2.84 8.56 4.92 7.56 5.92 7.56H20.8C22.12 7.56 23.52 8.84 23.52 10.88C23.52 12.76 22.36 14.24 20.72 14.24H9.96C9.16 14.24 9.12 15.08 9.12 15.32C8.8 21.84 8.92 29.6 9.16 34.76C9.24 36.44 8.08 38.04 5.76 38.04C2.88 38.04 2.32 35.84 2.28 34.96ZM20.52 26.76H12.76C11.56 26.76 10.32 25.28 10.32 23.4C10.32 21.68 11.56 20 12.8 20H20.56C21.64 20 23.04 21.24 23.04 23.32C23.04 25.04 22 26.76 20.52 26.76ZM50.6281 22.88C50.6281 31.32 46.3481 38.44 37.7081 38.44C29.2281 38.44 24.8681 31.12 24.8681 22.84C24.8681 14.56 28.7881 7.2 37.7081 7.2C46.7481 7.2 50.6281 15.12 50.6281 22.88ZM43.7081 22.92C43.7081 17.04 41.7081 13.96 37.6281 13.96C33.7881 14 31.7481 16.88 31.7481 22.92C31.7481 28.52 33.7481 31.64 37.6681 31.64C41.7081 31.64 43.7081 28.52 43.7081 22.92ZM66.9188 27.08H65.3188C63.5988 27.08 62.0388 25.92 62.0388 23.76C62.0388 22.12 63.1588 20.44 65.1588 20.44H65.9188C68.3188 20.44 70.3188 19.76 70.3188 17.28C70.3188 14.96 68.2388 14.24 66.3988 14.24H61.7988C60.8788 14.24 60.8388 15.08 60.8388 15.32C60.5188 21.84 60.7188 30.2 60.8788 35.28C60.9188 36.56 59.7988 38.04 57.4788 38.04C54.5988 38.04 54.0788 36.28 53.9988 35.32C53.7188 31.76 53.7188 13.84 54.2388 10.52C54.5588 8.4 56.6388 7.56 57.6788 7.56H65.7188C74.3187 7.56 77.1188 12.28 77.1188 17.32C77.1188 20.52 75.9188 23.52 73.3188 25.32C74.9188 28.96 76.1588 31.92 76.9988 34.04C77.5988 35.52 76.0788 37.32 74.7188 37.8C73.3188 38.32 71.3188 38.04 70.6788 36.48C69.5988 34.08 68.5988 31.16 66.9188 27.08Z",
    fill: "#FF7F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3481 13.6927L84.6031 11.2497C86.9676 10.5507 87.7621 7.54468 86.0651 5.75868L83.4306 2.98668C81.7336 1.20068 78.7396 1.89818 77.9206 4.21818L75.0621 12.3387C74.7761 13.1482 75.5251 13.9372 76.3481 13.6927Z",
    fill: "#FF8C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3481 13.6927L84.6031 11.2497C86.9676 10.5507 87.7621 7.54468 86.0651 5.75868L83.4306 2.98668C81.7336 1.20068 78.7396 1.89818 77.9206 4.21818L75.0621 12.3387C74.7761 13.1482 75.5251 13.9372 76.3481 13.6927Z",
    fill: "url(#paint0_linear_386_237)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3481 13.6927L84.6031 11.2497C86.9676 10.5507 87.7621 7.54468 86.0651 5.75868L83.4306 2.98668C81.7336 1.20068 78.7396 1.89818 77.9206 4.21818L75.0621 12.3387C74.7761 13.1482 75.5251 13.9372 76.3481 13.6927Z",
    fill: "url(#paint1_linear_386_237)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3481 13.6927L84.6031 11.2497C86.9676 10.5507 87.7621 7.54468 86.0651 5.75868L83.4306 2.98668C81.7336 1.20068 78.7396 1.89818 77.9206 4.21818L75.0621 12.3387C74.7761 13.1482 75.5251 13.9372 76.3481 13.6927Z",
    fill: "url(#paint2_radial_386_237)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3481 13.6927L84.6031 11.2497C86.9676 10.5507 87.7621 7.54468 86.0651 5.75868L83.4306 2.98668C81.7336 1.20068 78.7396 1.89818 77.9206 4.21818L75.0621 12.3387C74.7761 13.1482 75.5251 13.9372 76.3481 13.6927Z",
    fill: "url(#paint3_radial_386_237)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.5056 8.34665C80.6312 8.22701 80.7042 8.06242 80.7086 7.88901C80.713 7.7156 80.6484 7.54752 80.5291 7.42165L77.8026 4.55365L77.3151 5.93515L79.5801 8.31815C79.6387 8.3811 79.7093 8.4318 79.7876 8.46733C79.866 8.50287 79.9506 8.52253 80.0366 8.52518C80.1226 8.52783 80.2083 8.51341 80.2887 8.48277C80.3691 8.45213 80.4431 8.40587 80.5056 8.34665Z",
    fill: "url(#paint4_linear_386_237)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.48 10.6622C78.3543 10.7818 78.2812 10.9465 78.2768 11.12C78.2724 11.2936 78.337 11.4618 78.4565 11.5877L79.556 12.7447L80.961 12.3277L79.4005 10.6857C79.3417 10.6236 79.2713 10.5738 79.1932 10.539C79.1151 10.5043 79.0309 10.4852 78.9454 10.4831C78.86 10.4809 78.7749 10.4956 78.6951 10.5263C78.6154 10.557 78.5424 10.6032 78.4805 10.6622",
    fill: "url(#paint5_linear_386_237)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82.5516 7.24915C82.4258 7.36881 82.3527 7.5335 82.3483 7.70704C82.3439 7.88057 82.4085 8.04876 82.5281 8.17465L85.2181 11.0056C85.6082 10.8 85.9519 10.5164 86.2281 10.1726L83.4771 7.27765C83.4184 7.2147 83.3479 7.164 83.2695 7.12846C83.1911 7.09293 83.1065 7.07327 83.0205 7.07062C82.9345 7.06797 82.8488 7.08238 82.7684 7.11303C82.688 7.14367 82.6145 7.18993 82.5521 7.24915",
    fill: "url(#paint6_linear_386_237)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0686 0.315678C82.1726 1.04968 82.4181 2.07368 82.7606 2.45718C83.3824 3.08437 84.0074 3.70838 84.6356 4.32918C84.8261 4.45918 84.9631 4.43318 85.0791 4.40968C85.1651 4.39218 85.2426 4.32568 85.3061 4.21968C85.3591 4.13118 85.3091 2.71468 85.4261 1.42518C85.5136 0.463678 84.0886 -0.519822 83.0686 0.315678Z",
    fill: "#AAD248"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0686 0.315678C82.1726 1.04968 82.4181 2.07368 82.7606 2.45718C83.3824 3.08437 84.0074 3.70838 84.6356 4.32918C84.8261 4.45918 84.9631 4.43318 85.0791 4.40968C85.1651 4.39218 85.2426 4.32568 85.3061 4.21968C85.3591 4.13118 85.3091 2.71468 85.4261 1.42518C85.5136 0.463678 84.0886 -0.519822 83.0686 0.315678Z",
    fill: "url(#paint7_radial_386_237)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0686 0.315678C82.1726 1.04968 82.4181 2.07368 82.7606 2.45718C83.3824 3.08437 84.0074 3.70838 84.6356 4.32918C84.8261 4.45918 84.9631 4.43318 85.0791 4.40968C85.1651 4.39218 85.2426 4.32568 85.3061 4.21968C85.3591 4.13118 85.3091 2.71468 85.4261 1.42518C85.5136 0.463678 84.0886 -0.519822 83.0686 0.315678Z",
    fill: "url(#paint8_radial_386_237)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6585 6.0242C87.9035 6.9027 86.8855 6.6342 86.5105 6.2822C85.9571 5.71068 85.4024 5.14035 84.8465 4.5712C84.7215 4.3777 84.7495 4.2412 84.776 4.1262C84.7955 4.0402 84.8635 3.9642 84.971 3.9032C85.061 3.8527 86.3125 3.7282 87.604 3.6417C88.5675 3.5767 89.5175 5.0242 88.6585 6.0242Z",
    fill: "#AAD248"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6585 6.0242C87.9035 6.9027 86.8855 6.6342 86.5105 6.2822C85.9571 5.71068 85.4024 5.14035 84.8465 4.5712C84.7215 4.3777 84.7495 4.2412 84.776 4.1262C84.7955 4.0402 84.8635 3.9642 84.971 3.9032C85.061 3.8527 86.3125 3.7282 87.604 3.6417C88.5675 3.5767 89.5175 5.0242 88.6585 6.0242Z",
    fill: "url(#paint9_radial_386_237)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6585 6.0242C87.9035 6.9027 86.8855 6.6342 86.5105 6.2822C85.9571 5.71068 85.4024 5.14035 84.8465 4.5712C84.7215 4.3777 84.7495 4.2412 84.776 4.1262C84.7955 4.0402 84.8635 3.9642 84.971 3.9032C85.061 3.8527 86.3125 3.7282 87.604 3.6417C88.5675 3.5767 89.5175 5.0242 88.6585 6.0242Z",
    fill: "url(#paint10_radial_386_237)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6585 6.0242C87.9035 6.9027 86.8855 6.6342 86.5105 6.2822C85.9571 5.71068 85.4024 5.14035 84.8465 4.5712C84.7215 4.3777 84.7495 4.2412 84.776 4.1262C84.7955 4.0402 84.8635 3.9642 84.971 3.9032C85.061 3.8527 86.3125 3.7282 87.604 3.6417C88.5675 3.5767 89.5175 5.0242 88.6585 6.0242Z",
    fill: "url(#paint11_linear_386_237)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0495 0.688685C89.316 1.61669 88.6585 3.43869 87.604 3.64169C86.8515 3.78669 85.069 3.86019 85.069 3.86019C85.069 3.86019 85.213 2.06869 85.4165 1.46169C85.9085 -0.00681496 87.2605 0.110185 88.0495 0.688685Z",
    fill: "#AAD248"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0495 0.688685C89.316 1.61669 88.6585 3.43869 87.604 3.64169C86.8515 3.78669 85.069 3.86019 85.069 3.86019C85.069 3.86019 85.213 2.06869 85.4165 1.46169C85.9085 -0.00681496 87.2605 0.110185 88.0495 0.688685Z",
    fill: "url(#paint12_radial_386_237)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0495 0.688685C89.316 1.61669 88.6585 3.43869 87.604 3.64169C86.8515 3.78669 85.069 3.86019 85.069 3.86019C85.069 3.86019 85.213 2.06869 85.4165 1.46169C85.9085 -0.00681496 87.2605 0.110185 88.0495 0.688685Z",
    fill: "url(#paint13_radial_386_237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_386_237",
    x1: 72.7526,
    y1: 5.05568,
    x2: 79.7841,
    y2: 8.96218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#B3734C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#EA842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_386_237",
    x1: 84.2526,
    y1: 14.9932,
    x2: 81.5341,
    y2: 8.08718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#FF7CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF717B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8151 6.24318) rotate(131.009) scale(3.80994 7.6603)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFA427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA328",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.2837 10.8054) rotate(139.81) scale(11.3315 11.3002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#FF9243",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#F28B3A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#CB751F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_386_237",
    x1: 77.5966,
    y1: 5.64965,
    x2: 80.4716,
    y2: 8.36815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6E482A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_386_237",
    x1: 78.476,
    y1: 10.8117,
    x2: 79.795,
    y2: 13.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9E5044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C95D82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_386_237",
    x1: 82.6276,
    y1: 7.64965,
    x2: 85.1416,
    y2: 11.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#AA6147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB747C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.6591 1.11818) rotate(152.103) scale(1.20221 1.12852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1F26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEF62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8466 1.93068) rotate(170.615) scale(2.49136 3.51881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#8BC028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81AA56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.2213 4.68038) rotate(139.268) scale(1.48462 1.39362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1F26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEF62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.8935 4.5872) rotate(77.0973) scale(2.30828 6.04255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D029",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BA74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_386_237",
    x1: 87.862,
    y1: 3.3682,
    x2: 87.815,
    y2: 4.1497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#8ACE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91D212",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.775 1.23419) rotate(111.999) scale(1.37964 1.05539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1F26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEF62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_386_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.5655 1.77469) rotate(135) scale(5.56845 2.67504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#6FB909"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c74e075e83874ff0bd2a0533c070e594.svg";
export { ForwardRef as ReactComponent };